import React from "react";
import styles from "./graphicEqualiser.module.css";

export default function GraphicEqualiser({ ampVals }) {
  const displayVals = ampVals.slice(0, 12);

  return (
    <div className={styles.graphicEqualiser}>
      {displayVals.map((av, i) => (
        <Bar key={i} ampVal={av} />
      ))}
    </div>
  );
}

function Bar({ ampVal }) {
  const maxHeight = 35;
  const style = { height: 2 + maxHeight * ampVal };

  return <div className={styles.bar} style={style} />;
}
